import { authHeader, handleResponse } from '../helpers';
export const SecondaryPackingRptService = {
    fetchSecondaryPackingData   
};

function fetchSecondaryPackingData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}SecondaryPackingRpt/GetSecondaryPackingReport`, requestOptions)
        .then(handleResponse);
}